// @TODO: should this be in src/website/components?
/*
 * Ryan O'Dowd
 * 2025-01-01
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  DataTable,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const TableHead = (props: TableHeadProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <DataTable.Header style={styles.headerRow}>
      {props.headCells.map((headCell, index) => {
        // @TODO: should this be used? const disableCellSort = !props.isSortable || !headCell;
        const cellWidth = styles.globalScale * (headCell.width || 0);

        return (
          <DataTable.Title
            key={headCell.id}
            style={[styles.headerCell, cellWidth && {width: cellWidth, minWidth: cellWidth}, headCell.styles]}
            textStyle={[styles.textStyle(headCell.rightAlign, props.orderByIndex === index), headCell.textStyles]}
            numeric={headCell.rightAlign}
            numberOfLines={2}// @TODO: not working
            sortDirection={props.orderByIndex === index ? props.orderDirection : undefined}
            onPress={() => props.onRequestSort(index)}
          >
            {headCell.content}
          </DataTable.Title>
        );
      })}
    </DataTable.Header>
  );
};

class TableHeadProps {
  headCells: any[];
  onRequestSort: (index: number) => void;
  isSortable: boolean;

  orderDirection?: 'ascending' | 'descending' | undefined;
  orderByIndex?: number; // @TODO: required if isSortable is true
  lightBackground?: boolean;
};

TableHead.displayName = 'TableHead';
export default TableHead;
